import { FieldType, FormField, WidthClass } from '@thehubz/client/core';

export const westlottoFields: FormField[] = [
  {
    formTypeId: '1',
    formFieldName: 'length',
    fieldType: FieldType.Text,
    fieldLabel: $localize`Duration`,
    placeholder: $localize`Duration`,
    inputType: 'text',
    mandatory: false,
    validationRegex: '',
    widthClass: WidthClass.WFull,
    fieldGroup: 'tagging',
    disable: false,
    functionCall: false,
    formGroup: false,
    editable: true,
    visible: true,
  },
  {
    formTypeId: '1',
    formFieldName: 'motif',
    fieldType: FieldType.Text,
    fieldLabel: $localize`Motif`,
    placeholder: $localize`Motif`,
    inputType: 'text',
    mandatory: false,
    validationRegex: '',
    widthClass: WidthClass.WFull,
    fieldGroup: 'tagging',
    disable: false,
    functionCall: false,
    formGroup: false,
    editable: true,
    visible: true,
  },
  {
    formTypeId: '1',
    formFieldName: 'region',
    fieldType: FieldType.Text,
    fieldLabel: $localize`Region`,
    placeholder: $localize`Region`,
    inputType: 'text',
    mandatory: false,
    validationRegex: '',
    widthClass: WidthClass.WFull,
    fieldGroup: 'tagging',
    disable: false,
    functionCall: false,
    formGroup: false,
    editable: true,
    visible: true,
  },
  {
    formTypeId: '1',
    formFieldName: 'nextDrawingDay',
    fieldType: FieldType.Dropdown,
    fieldLabel: $localize`Next Drawing Day`,
    placeholder: $localize`Next Drawing Day`,
    inputType: 'text',
    mandatory: false,
    validationRegex: '',
    widthClass: WidthClass.WFull,
    fieldGroup: 'tagging',
    disable: false,
    functionCall: false,
    formGroup: false,
    editable: true,
    visible: true,
    options: [
      { name: $localize`Tuesday`, _id: 'tuesday' },
      { name: $localize`Friday`, _id: 'friday' },
      { name: $localize`Tuesdays and Fridays`, _id: 'tuesdaysAndFridays' },
      { name: $localize`Today`, _id: 'today' },
    ],
  },
  {
    formTypeId: '1',
    formFieldName: 'rang1',
    fieldType: FieldType.Text,
    fieldLabel: $localize`Rang1`,
    placeholder: $localize`Rang1`,
    inputType: 'text',
    mandatory: false,
    validationRegex: '',
    widthClass: WidthClass.WFull,
    fieldGroup: 'tagging',
    disable: false,
    functionCall: false,
    formGroup: false,
    editable: true,
    visible: true,
  },
  {
    formTypeId: '1',
    formFieldName: 'rang2',
    fieldType: FieldType.Text,
    fieldLabel: $localize`Rang2`,
    placeholder: $localize`Rang2`,
    inputType: 'text',
    mandatory: false,
    validationRegex: '',
    widthClass: WidthClass.WFull,
    fieldGroup: 'tagging',
    disable: false,
    functionCall: false,
    formGroup: false,
    editable: true,
    visible: true,
  },
  {
    formTypeId: '1',
    formFieldName: 'medium',
    fieldType: FieldType.Text,
    fieldLabel: $localize`Medium`,
    placeholder: $localize`Medium`,
    inputType: 'text',
    mandatory: false,
    validationRegex: '',
    widthClass: WidthClass.WFull,
    fieldGroup: 'tagging',
    disable: false,
    functionCall: false,
    formGroup: false,
    editable: true,
    visible: true,
  },
];
